import { useEffect, useState } from "react";
import icons from "../../assets/images/sprite-other-icons.svg";
import logo from "../../assets/images/logo-header.svg";
import gamePlayBg from "../../assets/images/banners/game-play-bg.jpg";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getFromLocalStorage } from "../../services/helper/cl_Helper";
import { endpoints } from "../../api/ApiEndPoints";
import { getGapLoadUrl } from "./cl_CrashSlice";
import axios from "axios";
import { socketConnect } from "../../services/socket/cl_index";
import { trackGameStartEvent } from "../../service/gtag";

const GameLaunch = () => {
  const { userDetails, balance } = useSelector((state) => state?.signIn);
  const [gameUrl, setGameUrl] = useState("");
  const [expandWin, setExpendWin] = useState(false);
  const localStorageToken = getFromLocalStorage("gk");
  const [token, setToken] = useState(localStorageToken);
  const [hasFetchedGapUrl, setHasFetchedGapUrl] = useState(false);
  const [isUserDetailsLoaded, setIsUserDetailsLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [iframeLoaded, setIframeLoaded] = useState(false);

  useEffect(() => {
    if (userDetails && userDetails.userId) {
      setIsUserDetailsLoaded(true);
    }
  }, [userDetails]);

  useEffect(() => {
    setToken(localStorageToken);
  }, [localStorageToken]);

  let location = useLocation();
  const dispatch = useDispatch();
  const [stateData, setStateData] = useState(null);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const stateParam = searchParams.get("state");
    if (stateParam) {
      // backward compat for old JSON format (pendingGame, bookmarks, etc.)
      setStateData(JSON.parse(decodeURIComponent(stateParam)));
    } else {
      // new format: individual query params
      const gameData = {
        game_code: searchParams.get("gamecode"),
        provider: searchParams.get("provider"),
        aggregator_type: searchParams.get("aggregator"),
        name: searchParams.get("name"),
        gamekind: searchParams.get("gamekind"),
        gamevariant: searchParams.get("gamevariant"),
        charged: searchParams.get("charged"),
        labelName: searchParams.get("labelname"),
        menuLink: searchParams.get("menulink"),
      };
      setStateData({
        gameData,
        gameClose: searchParams.get("gameclose") !== "false",
        returnPath: searchParams.get("returnpath"),
      });
    }
  }, [location.search]);

  const LoadGameData = stateData?.gameData;
  console.log("LoadGameData: ", LoadGameData);
  const gameclose = stateData?.gameClose;
  const [isGameOpen, setIsGameOpen] = useState(gameclose);
  var platformId = endpoints?.game_platform_id;
  var operatorId = endpoints?.game_operater_id;
  var gameBaseUrl = endpoints?.defender_end_point;
  var wacBasePath = endpoints?.wac_bace_path;
  var kironBasePath = endpoints?.kiron_basePath;
  var vleagueEndPoint = endpoints?.vleague;
  var WAC_PN = endpoints?.wac_pn;
  var vpsGame = endpoints?.penaltyShootout;
  var hub88_launch_url = endpoints?.hub88_basePath;
  const turboURL = process.env.REACT_APP_turbo;
  const stpUrl = process.env.REACT_APP_STP_LOAD_URL;
  const ezugiUrl = endpoints.ezugipath;
  const wacUrl = endpoints.wacEndpoint;
  const loginUser = endpoints.fasfasuser;
  const loginPass = endpoints.fasfasPass;
  const rootGameLaunch = endpoints.rootGameLaunch;
  const secretKey = endpoints.rootGameLaunchToken;
  const lobbyPath = endpoints.lobbyUrlPath;
  const depositPath = endpoints.depositUrlPath;
  const howzzatEndpoint = endpoints?.howzzatPath;
  const WAC_Load = `${wacBasePath}?token=${token}&pn=${WAC_PN}&lang=en&game=${LoadGameData?.game_code}&type=${LoadGameData?.charged}&home=http://${window.location.host}`;
  const kiron_Load = `${kironBasePath}&p=${token}&c=KES&l=en&s=default&eg=${LoadGameData?.game_code}`;
  const turbo_load = `https://${LoadGameData?.game_code}${turboURL}/?locale=en&cid=fasfas&token=${token}&demo=false`;
  const stp_load = `${stpUrl}${operatorId}/${LoadGameData?.gamekind}/${LoadGameData?.gamevariant}?token=${token}`;

  useEffect(() => {
    if (gameUrl) {
      const timer = setTimeout(() => {
        if (isLoading) {
          setIsLoading(false);
        }
      }, 10000);

      return () => clearTimeout(timer);
    }
  }, [gameUrl, isLoading]);

  useEffect(() => {
    if (iframeLoaded) {
      setIsLoading(false);
    }
  }, [iframeLoaded]);

  // useEffect(() => {
  //   if (isUserDetailsLoaded) {
  //     vleague_load = `${vleagueEndPoint}/games/vleague/index.html?platformId=${platformId}&operatorId=${operatorId}&gameCode=${LoadGameData?.game_code}&brand=${operatorId}&token=${token}&userNumber=${userDetails?.userName}&userId=${userDetails?.userId}&playerId=${userDetails?.userId}&userCulture=en-US&currencyCode=KES&languageCode=en&redir=true&referralLogin=false&referralRegister=false`;
  //     penaltyShootout = `${vpsGame}?platformId=${platformId}&operatorId=${operatorId}&brand=${operatorId}&gameCode=${LoadGameData?.game_code}&token=${token}&playerId=${userDetails?.userId}&playerName=${userDetails?.userName}&userCulture=en-US&currencyCode=KES&userRegion=KE&languageCode=en&gameName=penaltyshootout`;
  //     defenderURL = `${gameBaseUrl}?platformId=${platformId}&operatorId=${operatorId}&gameCode=${LoadGameData?.game_code}&AppSession=${token}&userId=${userDetails?.userId}&userNumber=${userDetails?.userName}&userCulture=en-US&currencyCode=KES&userRegion=KE`;
  //     howzzat_load = `${howzzatEndpoint}?platformId=${platformId}&operatorId=${operatorId}&gameCode=${LoadGameData?.game_code}&AppSession=${token}&userId=${userDetails?.userId}&userNumber=${userDetails?.userName}&userCulture=en-US&currencyCode=KES&languageCode=en`;
  //   }
  // }, [userDetails, isUserDetailsLoaded]);

  // useEffect(() => {
  //   const fetchNePlayUrl = async () => {
  //     try {
  //       const response = await axios.post(
  //         rootGameLaunch,
  //         {
  //           userId: userDetails.userId,
  //           playerToken: token,
  //           currency: "KES",
  //           gameId: LoadGameData?.game_code,
  //           token: secretKey,
  //           demoGame: false,
  //           provider: LoadGameData?.provider,
  //         },
  //         {
  //           headers: {
  //             "Content-Type": "application/json",
  //           },
  //         }
  //       );

  //       if (response.data?.play_url) {
  //         setGameUrl(response.data.play_url);
  //       } else if (response.data?.errorCode) {
  //         console.error("NePlay Error:", response.data.errorMessage);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching NePlay URL:", error);
  //     }
  //   };

  //   if (
  //     isUserDetailsLoaded &&
  //     LoadGameData?.provider.toLowerCase() === "NeGames".toLowerCase()
  //   ) {
  //     fetchNePlayUrl();
  //   }
  // }, [LoadGameData, token, userDetails.userId, isUserDetailsLoaded]);

  // useEffect(() => {
  //   const fetchAndromedaUrl = async () => {
  //     if (
  //       !token ||
  //       !LoadGameData?.gameCode ||
  //       !operatorId ||
  //       !isUserDetailsLoaded
  //     )
  //       return;

  //     try {
  //       const response = await axios.post(
  //         wacUrl,
  //         {
  //           message: {
  //             method: {
  //               name: "getGameLaunchURL",
  //               credentials: {
  //                 login: loginUser,
  //                 password: loginPass,
  //               },
  //               params: {
  //                 token: {
  //                   value: token,
  //                 },
  //                 gameCode: {
  //                   value: LoadGameData?.gameCode,
  //                 },
  //                 device: {
  //                   value: LoadGameData?.device,
  //                 },
  //                 type: {
  //                   value: "CHARGED",
  //                 },
  //                 operatorId: {
  //                   value: operatorId,
  //                 },
  //               },
  //             },
  //           },
  //         },
  //         {
  //           headers: {
  //             "Content-Type": "application/json",
  //           },
  //         }
  //       );
  //       setGameUrl(response?.data?.url);
  //     } catch (error) {
  //       console.error("Error fetching game URL:", error);
  //     }
  //   };

  //   if (
  //     (LoadGameData?.provider === "leap" ||
  //       LoadGameData?.provider === "habanero") &&
  //     isUserDetailsLoaded
  //   ) {
  //     fetchAndromedaUrl();
  //   }
  // }, [token, LoadGameData, operatorId, isUserDetailsLoaded]);

  // useEffect(() => {
  //   const fetchGapLoadUrl = async () => {
  //     if (!hasFetchedGapUrl && isUserDetailsLoaded) {
  //       let request = {
  //         token: token,
  //         playerId: userDetails.userId + "",
  //         providerName: LoadGameData?.provider,
  //         deviceType: "MOBILE",
  //         lobby: false,
  //         balance: balance,
  //         clientIp: "127.0.0.1",
  //         redirectUrl: process.env.REACT_APP_FASFASREFERURL,
  //         extraData: {
  //           currency: "KES",
  //           platformId: "1",
  //           operatorId: "fasfas",
  //           brand: "fasfas",
  //           region: "KE",
  //           language: "en",
  //           gameId: LoadGameData.game_id,
  //           playerName: userDetails.userName,
  //         },
  //       };

  //       if (balance && userDetails.userId) {
  //         const result = await dispatch(getGapLoadUrl(request));
  //         if (result) {
  //           setGameUrl(result.url);
  //           setHasFetchedGapUrl(true);
  //         }
  //       }
  //     }
  //   };

  //   if (
  //     isUserDetailsLoaded &&
  //     (LoadGameData?.provider === "EVOLUTION" ||
  //       LoadGameData?.provider === "EZUGI" ||
  //       LoadGameData?.provider === "netent" ||
  //       LoadGameData?.provider === "RG" ||
  //       LoadGameData?.provider === "DC" ||
  //       LoadGameData?.provider === "JiLi")
  //   ) {
  //     fetchGapLoadUrl();
  //   } else if (LoadGameData?.provider === "turbogames") {
  //     setGameUrl(turbo_load);
  //   } else if (
  //     LoadGameData?.provider === "Split The Pot" ||
  //     LoadGameData?.provider === "stp"
  //   ) {
  //     setGameUrl(stp_load);
  //   } else if (LoadGameData?.provider === "kiron") {
  //     setGameUrl(kiron_Load);
  //   }
  // }, [LoadGameData, balance, token, isUserDetailsLoaded]);
  // useEffect(() => {
  //   const fetchEzugiUrl = async () => {
  //     if (!gameUrl && isUserDetailsLoaded) {
  //       const url = ezugiUrl;
  //       const time = Date.now();
  //       const game_code = LoadGameData?.game_code;
  //       const tableId = game_code?.includes("_")
  //         ? game_code?.split("_")[1]
  //         : game_code;
  //       const params = {
  //         playerId: userDetails.userId + "",
  //         operatorId: operatorId,
  //         token: token,
  //         currencyCode: "KES",
  //         openTable: Number(tableId),
  //         timestamp: time,
  //       };
  //       try {
  //         const response = await axios.post(url, params, {
  //           headers: {
  //             "Content-Type": "application/json",
  //           },
  //         });
  //         setGameUrl(response?.data?.url);
  //       } catch (error) {
  //         console.error("Error fetching Ezugi URL:", error);
  //       }
  //     }
  //   };

  //   if (LoadGameData?.provider === "ezugi" && isUserDetailsLoaded) {
  //     fetchEzugiUrl();
  //   }
  // }, [
  //   LoadGameData,
  //   token,
  //   userDetails.userId,
  //   operatorId,
  //   isUserDetailsLoaded,
  // ]);

  useEffect(() => {
    const fetchNePlayUrl = async () => {
      if (!gameUrl && isUserDetailsLoaded) {
        try {
          const url = hub88_launch_url;
          const time = Date.now();
          const game_code = LoadGameData?.game_code;
          if (
            !url ||
            !game_code ||
            !token ||
            !userDetails?.userId ||
            !operatorId
          ) {
            console.error("Missing required parameters for Hub88 launch");
            return;
          }

          const params = {
            playerId: userDetails.userId.toString(),
            platformId: 1,
            operatorId: operatorId,
            brandId: operatorId,
            playerToken: token,
            currencyCode: "KES",
            gameId: game_code,
            aggregator: LoadGameData?.aggregator_type?.toLowerCase(),
            provider: LoadGameData?.provider,
            technology: "H5",
            gamePlatform: "WEB",
            playerIp: userDetails?.ip || "127.0.0.1",
            timestamp: time,
            countryCode: userDetails?.country || "KE",
            lobbyUrl: lobbyPath,
            depositUrl: depositPath,
          };

          const response = await axios.post(url, params, {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          });

          if (response?.data?.launchUrl) {
            setGameUrl(response.data.launchUrl);
          } else {
            console.error("No launch URL in response:", response.data);
          }
        } catch (error) {
          console.error("Error fetching Hub88 URL:", error.response || error);
        }
      }
    };

    // if (
    //   LoadGameData?.aggregator_type?.toLowerCase() === "negames" &&
    //   isUserDetailsLoaded
    // ) {
    fetchNePlayUrl();
    // }
  }, [
    LoadGameData,
    token,
    userDetails.userId,
    operatorId,
    isUserDetailsLoaded,
  ]);
  // useEffect(() => {
  //   const fetchEzugiUrl = async () => {
  //     if (!gameUrl && isUserDetailsLoaded) {
  //       try {
  //         const url = hub88_launch_url;
  //         const time = Date.now();
  //         const game_code = LoadGameData?.game_code;
  //         if (
  //           !url ||
  //           !game_code ||
  //           !token ||
  //           !userDetails?.userId ||
  //           !operatorId
  //         ) {
  //           console.error("Missing required parameters for Hub88 launch");
  //           return;
  //         }

  //         const params = {
  //           playerId: userDetails.userId.toString(),
  //           platformId: 1,
  //           operatorId: operatorId,
  //           brandId: operatorId,
  //           playerToken: token,
  //           currencyCode: "KES",
  //           gameId: game_code,
  //           aggregator: LoadGameData?.aggregator_type?.toLowerCase(),
  //           provider: LoadGameData?.provider,
  //           technology: "H5",
  //           gamePlatform: "WEB",
  //           playerIp: userDetails?.ip || "127.0.0.1",
  //           timestamp: time,
  //           countryCode: userDetails?.country || "KE",
  //           lobbyUrl: lobbyPath,
  //           depositUrl: depositPath,
  //         };

  //         const response = await axios.post(url, params, {
  //           headers: {
  //             "Content-Type": "application/json",
  //             Accept: "application/json",
  //           },
  //         });

  //         if (response?.data?.launchUrl) {
  //           setGameUrl(response.data.launchUrl);
  //         } else {
  //           console.error("No launch URL in response:", response.data);
  //         }
  //       } catch (error) {
  //         console.error("Error fetching Hub88 URL:", error.response || error);
  //       }
  //     }
  //   };

  //   if (
  //     LoadGameData?.aggregator_type?.toLowerCase() === "ezugi" &&
  //     isUserDetailsLoaded
  //   ) {
  //     fetchEzugiUrl();
  //   }
  // }, [
  //   LoadGameData,
  //   token,
  //   userDetails.userId,
  //   operatorId,
  //   isUserDetailsLoaded,
  // ]);

  // useEffect(() => {
  //   const fetchHub88Url = async () => {
  //     if (!gameUrl && isUserDetailsLoaded) {
  //       try {
  //         const url = hub88_launch_url;
  //         const time = Date.now();
  //         const game_code = LoadGameData?.game_code;
  //         if (
  //           !url ||
  //           !game_code ||
  //           !token ||
  //           !userDetails?.userId ||
  //           !operatorId
  //         ) {
  //           console.error("Missing required parameters for Hub88 launch");
  //           return;
  //         }

  //         const params = {
  //           playerId: userDetails.userId.toString(),
  //           platformId: 1,
  //           operatorId: operatorId,
  //           brandId: operatorId,
  //           playerToken: token,
  //           currencyCode: "KES",
  //           gameId: game_code,
  //           aggregator: LoadGameData?.aggregator_type?.toLowerCase(),
  //           provider: LoadGameData?.provider,
  //           technology: "H5",
  //           gamePlatform: "WEB",
  //           playerIp: userDetails?.ip || "127.0.0.1",
  //           timestamp: time,
  //           countryCode: userDetails?.country || "KE",
  //           lobbyUrl: lobbyPath,
  //           depositUrl: depositPath,
  //         };

  //         const response = await axios.post(url, params, {
  //           headers: {
  //             "Content-Type": "application/json",
  //             Accept: "application/json",
  //           },
  //         });

  //         if (response?.data?.launchUrl) {
  //           setGameUrl(response.data.launchUrl);
  //         } else {
  //           console.error("No launch URL in response:", response.data);
  //         }
  //       } catch (error) {
  //         console.error("Error fetching Hub88 URL:", error.response || error);
  //       }
  //     }
  //   };

  //   if (
  //     LoadGameData?.aggregator_type?.toLowerCase() === "hub88" &&
  //     isUserDetailsLoaded
  //   ) {
  //     fetchHub88Url();
  //   }
  // }, [
  //   LoadGameData,
  //   token,
  //   userDetails.userId,
  //   operatorId,
  //   isUserDetailsLoaded,
  // ]);

  // useEffect(() => {
  //   const fetchBoomingGames = async () => {
  //     if (!gameUrl && isUserDetailsLoaded) {
  //       try {
  //         const url = hub88_launch_url;
  //         const time = Date.now();
  //         const game_code = LoadGameData?.game_code;
  //         if (
  //           !url ||
  //           !game_code ||
  //           !token ||
  //           !userDetails?.userId ||
  //           !operatorId
  //         ) {
  //           console.error("Missing required parameters for Hub88 launch");
  //           return;
  //         }
  //         const params = {
  //           playerId: userDetails.userId.toString(),
  //           platformId: 1,
  //           operatorId: operatorId,
  //           brandId: operatorId,
  //           playerToken: token,
  //           currencyCode: userDetails?.currency || "KES",
  //           gameId: game_code,
  //           aggregator: LoadGameData?.aggregator_type?.toLowerCase(),
  //           provider: LoadGameData?.provider,
  //           technology: "H5",
  //           gamePlatform: "WEB",
  //           playerIp: userDetails?.ip || "127.0.0.1",
  //           timestamp: time,
  //           countryCode: userDetails?.country || "KE",
  //           language: userDetails?.language || "en",
  //           returnUrl: window.location.origin,
  //           demo: false,
  //           lobbyUrl: lobbyPath,
  //           depositUrl: depositPath,
  //         };

  //         const response = await axios.post(url, params, {
  //           headers: {
  //             "Content-Type": "application/json",
  //             Accept: "application/json",
  //           },
  //         });

  //         if (response?.data?.launchUrl) {
  //           setGameUrl(response.data.launchUrl);
  //         } else {
  //           console.error("No launch URL in response:", response.data);
  //         }
  //       } catch (error) {
  //         console.error("Error fetching Hub88 URL:", error.response || error);
  //       }
  //     }
  //   };

  //   if (
  //     LoadGameData?.aggregator_type?.toLowerCase() === "booming" &&
  //     isUserDetailsLoaded
  //   ) {
  //     fetchBoomingGames();
  //   }
  // }, [
  //   LoadGameData,
  //   token,
  //   userDetails.userId,
  //   operatorId,
  //   isUserDetailsLoaded,
  // ]);

  // useEffect(() => {
  //   const fetchShacksevo = async () => {
  //     if (!gameUrl && isUserDetailsLoaded) {
  //       try {
  //         const url = hub88_launch_url;
  //         const game_code = LoadGameData?.game_code;
  //         if (
  //           !url ||
  //           !game_code ||
  //           !token ||
  //           !userDetails?.userId ||
  //           !operatorId
  //         ) {
  //           console.error("Missing required parameters for Hub88 launch");
  //           return;
  //         }

  //         const params = {
  //           playerId: userDetails.userId.toString(),
  //           platformId: 1,
  //           operatorId: operatorId,
  //           brandId: operatorId,
  //           playerToken: token,
  //           currencyCode: userDetails?.currency || "KES",
  //           gameId: game_code,
  //           aggregator: LoadGameData?.aggregator_type?.toLowerCase(),
  //           provider: LoadGameData?.provider,
  //           technology: "H5",
  //           gamePlatform: "WEB",
  //           playerIp: userDetails?.ip || "127.0.0.1",
  //           countryCode: userDetails?.country || "KE",
  //           language: userDetails?.language || "en",
  //           lobbyUrl: lobbyPath,
  //           depositUrl: depositPath,
  //         };

  //         const response = await axios.post(url, params, {
  //           headers: {
  //             "Content-Type": "application/json",
  //             Accept: "application/json",
  //           },
  //         });

  //         if (response?.data?.launchUrl) {
  //           setGameUrl(response.data.launchUrl);
  //         } else {
  //           console.error("No launch URL in response:", response.data);
  //         }
  //       } catch (error) {
  //         console.error("Error fetching Hub88 URL:", error.response || error);
  //       }
  //     }
  //   };

  //   if (
  //     LoadGameData?.aggregator_type?.toLowerCase() === "shacksevo" &&
  //     isUserDetailsLoaded
  //   ) {
  //     fetchShacksevo();
  //   }
  // }, [
  //   LoadGameData,
  //   token,
  //   userDetails.userId,
  //   operatorId,
  //   isUserDetailsLoaded,
  // ]);

  const navigate = useNavigate();

  const expendHandiler = () => {
    setExpendWin(!expandWin);

    let elem = document.getElementById("fullscreen");

    if (!expandWin) {
      // Request fullscreen
      try {
        if (elem.requestFullscreen) {
          elem.requestFullscreen();
        } else if (elem.webkitRequestFullscreen) {
          /* Safari */
          elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) {
          /* IE11 */
          elem.msRequestFullscreen();
        }
      } catch (error) {
        console.error("Error entering fullscreen:", error);
      }
    } else {
      // Exit fullscreen
      try {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          /* Safari */
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          /* IE11 */
          document.msExitFullscreen();
        }
      } catch (error) {
        console.error("Error exiting fullscreen:", error);
      }
    }
  };

  useEffect(() => {
    const pendingGame = localStorage.getItem("pendingGame");
    if (!LoadGameData && pendingGame) {
      try {
        const game = JSON.parse(pendingGame);
        const gameData = game.game ? game.game : game;
        setStateData({
          gameData,
          gameClose: false,
        });
      } catch (error) {
        console.error("Error parsing pending game:", error);
        navigate("/");
      }
    }
  }, []);

  useEffect(() => {
    if (LoadGameData) {
      const currentGames = localStorage.getItem("categoryGames");
      if (currentGames) {
        const parsedGames = JSON.parse(currentGames);
        localStorage.setItem(
          "categoryGames",
          JSON.stringify({
            ...parsedGames,
            currentGame: LoadGameData,
          })
        );
      }
    }
  }, [LoadGameData]);

  useEffect(() => {
    if (gameUrl && LoadGameData && userDetails?.userId && secretKey) {
      trackGameStartEvent(
        LoadGameData?.name || LoadGameData?.game_code || "Unknown Game",
        LoadGameData?.provider || "unknown",
        userDetails.userOtherInfo.phone,
        userDetails?.userType || "existing"
      );
    }
  }, [gameUrl, LoadGameData, userDetails, secretKey]);

  const goBack = () => {
    setGameUrl("");
    setIsGameOpen(false);
    setIframeLoaded(false);
    setIsLoading(true);
    localStorage.removeItem("pendingGame");

    const returnPath = stateData?.returnPath;
    const previousPath = localStorage.getItem("previousGamePath");
    const categoryGames = localStorage.getItem("categoryGames");

    if (returnPath) {
      navigate(returnPath);
    } else if (previousPath && categoryGames) {
      const { categoryName, gamesList } = JSON.parse(categoryGames);
      localStorage.removeItem("previousGamePath");
      navigate(previousPath, {
        state: {
          gamesList,
          title: categoryName,
          game_type: categoryName,
        },
      });
    } else {
      navigate("/");
    }
  };

  const handleIframeLoad = () => {
    setIframeLoaded(true);
    setIsLoading(false);
  };
  const [showStakeModal, setShowStakeModal] = useState(false);
  const [stakeInfo, setStakeInfo] = useState({
    stake: "",
    minStake: "",
    maxStake: "",
    gameName: "",
    message: "",
    betId: "",
    minStakeAmount: "",
    rejectionCode: "",
    maxStakeAmount: "",
  });

  useEffect(() => {
    socketConnect(dispatch);

    const handleBetRejection = (event) => {
      try {
        const data = event.detail;
        if (data.notificationType === "BET_REJECTED") {
          const betData = JSON.parse(data.data);
          if (
            betData.rejectionCode === "GAME_MIN_STAKE_VALUE_NOT_MET" ||
            betData.rejectionCode === "GAME_MAX_STAKE_LIMIT_EXCEEDED"
          ) {
            const minStakeAmount = Number(betData.gameMinStake) / 100;
            const maxStakeAmount = Number(betData.gameMaxStake) / 100;
            const userStake = Number(betData.stake);

            setStakeInfo({
              minStake: minStakeAmount,
              maxStake: maxStakeAmount,
              gameName: betData.gameName,
              betId: betData.betId,
              minStakeAmount: minStakeAmount,
              maxStakeAmount: maxStakeAmount,
              userStake: userStake,
              rejectionCode: betData.rejectionCode,
              message:
                betData.rejectionCode === "GAME_MIN_STAKE_VALUE_NOT_MET"
                  ? `Minimum stake for the game is `
                  : `Maximum stake for the game is `,
            });
            setShowStakeModal(true);
          }
        }
      } catch (error) {
        console.error("Error handling bet rejection:", error);
      }
    };

    window.addEventListener("notification", handleBetRejection);

    return () => {
      window.removeEventListener("notification", handleBetRejection);
    };
  }, [dispatch]);

  const handleCloseModal = () => {
    window.location.reload();
    setTimeout(() => {
      setShowStakeModal(false);
    }, 100);
  };

  return (
    <div className="SB-Lite SB-casinoGamePlayPage" id="fullscreen">
      {showStakeModal && (
        <div className="SB-modal SB-gameInfoModal open">
          <div className="SB-modal-dialog">
            <div className="SB-modal-content">
              <div className="SB-modal-close" onClick={handleCloseModal}>
                <div className="SB-iconSVG" title="close">
                  <svg xmlns="http://www.w3.org/2000/svg">
                    <use xlinkHref={`${icons}#icon-close`}></use>
                  </svg>
                </div>
              </div>
              <div className="SB-modal-body">
                <div className="SB-modal-header">
                  <div className="SB-modal-title">Bet Rejection</div>
                </div>
                <iframe src="https://lottie.host/embed/eedafe27-fd1f-4109-8e86-51bfbc396d99/peU7viMeD3.lottie" title="Bet Rejection Animation"></iframe>
                <div className="SB-gameplay-info">
                  <div className="SB-title SB-gameName">
                    <span>Game Name:</span> {stakeInfo.gameName}
                  </div>
                  <div className="SB-title SB-betID">
                    <span>ID:</span> {stakeInfo.betId}
                  </div>
                  <div className="SB-gameBet-rejected">
                    <p>
                      {stakeInfo.message}
                      <span className="SB-gameStake">
                        KSH{" "}
                        {stakeInfo.rejectionCode ===
                          "GAME_MIN_STAKE_VALUE_NOT_MET"
                          ? stakeInfo.minStakeAmount
                          : stakeInfo.maxStakeAmount}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="SB-casinoGamePlay">
        <div
          className="SB-casinoGamePlay-container"
          style={{ backgroundImage: `url(${gamePlayBg})` }}
        >
          <div className="SB-casinoGamePlay-box">
            <div className="SB-casinoGamePlay-boxHeader">
              <div className="SB-casinoGamePlay-boxHeader__left">
                <img src={logo} alt="Logo" />
                <div className="SB-casinoGamePlay-title">
                  {LoadGameData?.name}{" "}
                </div>
              </div>
              <div className="SB-casinoGamePlay-boxHeader__right">
                <div className="SB-casinoGameExpand">
                  <div className="SB-iconSVG" onClick={expendHandiler}>
                    <svg xmlns="http://www.w3.org/2000/svg">
                      <use xlinkHref={`${icons}#${"icon-expand"}`} />
                    </svg>
                  </div>
                </div>
                <div className="SB-casinoGameClose" onClick={goBack}>
                  <div className="SB-iconSVG">
                    <svg xmlns="http://www.w3.org/2000/svg">
                      <use xlinkHref={`${icons}#${"icon-close"}`} />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="SB-casinoGamePlay-boxContent"
              style={{ position: "relative" }}
            >
              {isLoading && gameUrl && (
                <div className="SB-loader-container">
                  <div className="SB-loader"></div>
                </div>
              )}
              {gameUrl && (
                <iframe
                  id="virtualFrame"
                  src={gameUrl}
                  scrolling="yes"
                  height="100dvh"
                  width="100%"
                  frameBorder="0"
                  onLoad={handleIframeLoad}
                  title="Game Player"
                ></iframe>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GameLaunch;
